<template>
  <!--
  作者：luoyiming
  时间：2019-10-24
  描述：健康资讯
  -->
  <div>
    <!--nav start-->
    <div id="nav">
      <ul class="nav">
        <li :class="routerstr.indexOf('index')!=-1?'active':''" @click="pageClick('/index')">首页</li>
        <li :class="routerstr.indexOf('notice')!=-1?'active':''" @click="pageClick('/notice')">医院通知</li>
        <li :class="routerstr.indexOf('news')!=-1?'active':''" @click="pageClick('/news')">新闻中心</li>
        <li :class="routerstr.indexOf('message')!=-1?'active':''" @click="pageClick('/message')">信息公告</li>
        <li :class="routerstr.indexOf('department')!=-1?'active':''" @click="pageClick('/department')">科室介绍</li>
        <li :class="routerstr.indexOf('information')!=-1?'active':''" @click="pageClick('/information')">健康资讯</li>
        <li :class="routerstr.indexOf('contact')!=-1?'active':''" @click="pageClick('/contact')">联系我们</li>
      </ul>
    </div>
    <!--nav end-->
    <div class="departmentdetail">
      <div class="departmentdetail_title">{{data.roomName}}</div>
      <div class="departmentdetail_content">
       
        <div class="departmentdetail_content_img">
          <img class="departmentdetail_content_img_image" :src="'/dev-api'+data.coverPicPath" width="880" height="700" alt="">
        </div>
        <div class="departmentdetail_content_info">
          <div class="departmentdetail_content_info_title">科室介绍</div>
          <div class="departmentdetail_content_info_content" v-html="data.introduce"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import IndexApi from '@/api/index.js';
  export default {
    data() {
      return {
        routerstr:'/department',
        /*是否正在加载*/
        loading: true,
        /*背景图片*/
        bgimg_url: '',
        /*是否正在提交*/
        logining: false,
        /*基础配置*/
        id:0,
        data:{},
      };
    },
    onload(){

    },
    created() {
      const params = this.$route.query;
      this.id = params.id;
      this.getData();
      this.routerstr = this.$router.currentRoute.path;
    },
    methods: {
      /*页面跳转*/
      pageClick(row,id) {
        this.$router.push({path:row,query:{id:id}});
      },
      getData() {
        let self = this;
        var data = {
          roomId:self.id,
        }
        IndexApi.departmentdetail(data,true)
          .then(res => {
            self.loading = false;
            self.data = res.data;
          })
          .catch(error => {
            self.loading = false;
          });
      },
    }
  };
</script>

<style lang="scss" scoped>
  .departmentdetail{
    width:1200px;margin:0 auto;
    .departmentdetail_title{padding:23px 0 40px;border-bottom: 2px solid #DEDEDE;height:113px;line-height: 50px;font-size:36px;color:#333;text-align: center;}
    .departmentdetail_content{
     
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding:40px 0 0 0;
      .departmentdetail_content_info{
        margin-left: 20px;
       box-shadow: 0px 0px 11px 0px rgba(0,0,0,0.25);
        .departmentdetail_content_info_title{
          height:40px;line-height: 40px;margin:20px 30px;font-size:28px;color:#333;
        }
        .departmentdetail_content_info_content{
          padding:0 40px 40px;font-size:18px;color:#666;line-height: 28px;-webkit-background-clip: text;overflow-y: auto;
        }
      }
      .departmentdetail_content_img{
        padding:0 0 0 40px;
        .departmentdetail_content_img_image{width:400px;height:500px;border: 2px solid #DEDEDE;}
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/departmentdetail.vue